import CallApi from '../hooks/callApi';

export async function fetchSendMessage(query, session_id) {
  return CallApi({
    method: 'POST',
    url: '/ask-sync',
    data: {
      question: query,
      session_id,
    },
  });
}

